import * as actions from "../actions/"

import {toast} from "react-toastify"

const defaultState = {
  fetching: false,
  running: false,
  info: {},
  data: {}
}

export default function reducer(state = defaultState, action) {

  switch (action.type) {
    case actions.START_VERIFICATION.PENDING: {
      return {...defaultState, fetching: true, running: true}
    }
    case actions.START_VERIFICATION.ERROR: {
      return {...state, fetching: false, error: action.payload}
    }
    case actions.START_VERIFICATION.SUCCESS: {
      return {
        ...state,
        fetching: false,
        running: true,
        info: {}
      }
    }

    case actions.FETCH_VERIFICATION.PENDING: {
      return {...state, fetching: true, info: {}, errors:[]}
    }
    case actions.FETCH_VERIFICATION.ERROR: {
      return {...state, running: false, error: action.payload}
    }
    case actions.FETCH_VERIFICATION.UPDATE: {
      return {...state, data: action.payload }
    }
    case actions.FETCH_VERIFICATION.SUCCESS: {
      //TODO: Maybe check error code instead of status
      if (action.payload.status === 'success')
        toast.success("Verification finished!");
      else if (action.payload.status === 'warning')
        toast.warn("Verification finished with warnings");
      else
        toast.error("Verification failed!");
      return {
        ...state,
        running: false,
        data: action.payload,
        errors: action.payload.errors
      }
    }

    case actions.SALESFORCE_PUSH.PENDING: {
      return {...state}
    }
    case actions.SALESFORCE_PUSH.ERROR: {
      toast.error("Something went wrong while attempting to push.");
      return {...state, error: action.payload}
    }
    case actions.SALESFORCE_PUSH.SUCCESS: {
      if (action.payload.error) {
        toast.error(action.payload.error);
      }else{
        toast.success("Pushed to salesforce");
      }
      return {...state}
    }
  }
  return state
}


// WEBPACK FOOTER //
// ./src/reducers/verificationReducer.js